import httpRequest from "utils/httpRequest";

const URL = "/api";

export const postLogin = async (user_id, fn_password) => {
  const requestBody = {
    user_id,
    fn_password,
  };
  const response = await httpRequest("post", `${URL}/login`, requestBody);
  return response;
};

export const postLogout = async () => {
  const response = await httpRequest("post", `${URL}/logout`);
  return response;
};
